import React, { Component } from 'react';
import uuid from "uuid";
import logo from './../images/eliminar.png'
class getSubCombo extends Component {
  constructor(){
    super();
    this.state = {
        array_nota_combo : [] ,
        id_subgrupo_default : 0,
        array_nota_combo_sub : [] ,
        array_nota_combo_sel : [] ,
        ac_array_nota_combo_sel : 0,
        combo:''
    }
  }
  buscar_subitems = (id_subgrupo_default) => {
    const array_nota_combo = this.state.array_nota_combo;
    if(array_nota_combo.length === 0) return null;
    for (var i = 0; i < array_nota_combo.length; i++) {
      if(id_subgrupo_default===array_nota_combo[i].id_subgrupo){
          this.setState({
            array_nota_combo_sub : array_nota_combo[i].Citems
          })
          return null;
      }
    }
  }
  add_subitems = (id_subgrupo,id_item,item,precio_venta, iva, servicio, sw_incluido, id_rubro, id_subrubro, pfinal,sw_precio) =>{
    //console.log("dd"+sw_precio)
    if(Number(sw_precio)===0){
      precio_venta=0;
      iva=0;
      servicio=0;
      sw_incluido=0;
      pfinal =0;
    }
    const array_nota_combo = this.state.array_nota_combo;
    const array_nota_combo_sel = this.state.array_nota_combo_sel;
    let cantidad_max = this.props.cantidad_max;
    if(cantidad_max===0)cantidad_max=999999;
    let cantidad_grupo = -1;
    let id_subrubro_next ="";
    for (var i = array_nota_combo.length-1; i >=0; i--) {
      if(id_subgrupo===array_nota_combo[i].id_subgrupo){
           cantidad_grupo = Number(array_nota_combo[i].cantidad);
           break;
      }
      id_subrubro_next = array_nota_combo[i].id_subgrupo;
    }

    let cantidad_global = array_nota_combo_sel.length;
    for (var o = array_nota_combo_sel.length-1; o >=0 ; o--) {
      if(id_subgrupo===array_nota_combo_sel[o].id_subgrupo){
          if(Number(array_nota_combo_sel[o].precio_unitario)<=0){
           cantidad_grupo--;
           break;
         }
      }

    }
//console.log(cantidad_max+" "+cantidad_grupo+" "+cantidad_global);

    if(cantidad_global<cantidad_max&&cantidad_grupo>0){
      //console.log(cantidad_max+" "+cantidad_grupo+" "+cantidad_global);
      let ac_array_nota_combo_sel = this.state.ac_array_nota_combo_sel;
      ac_array_nota_combo_sel++;
      let nombre_item =item;
      let costo_unitario=pfinal;
      let cantidad = 1;
      const roundTo = require('round-to');
      let costo =  roundTo(Number(pfinal)* Number(cantidad),2);
      let impuesto_IVA=iva;
      let impuesto_Servicio=servicio;

      this.setState({
       array_nota_combo_sel: [ ...this.state.array_nota_combo_sel, {
         'secuencial': ac_array_nota_combo_sel,
         'opcion': '',
         'cantidad' : 1,
         'detalle' : nombre_item,
         'precio_total' : costo ,
         'precio_unitario' : costo_unitario ,
         'impuesto_IVA' : impuesto_IVA ,
         'impuesto_Servicio' : impuesto_Servicio ,
         'id_detalle' : 0 ,
         'cant_eliminada' : 0 ,
         'id_item' : id_item ,
         'id_rubro' : id_rubro ,
         'id_subgrupo' : id_subgrupo ,
         'id_subrubro' : id_subrubro ,
         'precio_venta' : precio_venta ,
         'preferencia' :''
       }], ac_array_nota_combo_sel });

       //************************** VERIRICAR SI CAMBIA
       if(cantidad_grupo===1&&id_subrubro_next!==''){
         this.buscar_subitems(id_subrubro_next);
       }

    }


  }
  renderTableBoton = () => {
    const array_nota_combo = this.state.array_nota_combo;
    if(array_nota_combo.length === 0) return null;
    return (
      <React.Fragment>
        {array_nota_combo.map(item => (
          <span key={item.id_subgrupo} className="boton_item_subgrupo"><button onClick={ () => this.buscar_subitems(item.id_subgrupo)} className="boton_item_span_subgrupo">{item.subrubro}</button></span>
          ))}
      </React.Fragment>
    )
  }

  renderTableBotonChild = () => {
    const array_nota_combo_sub = this.state.array_nota_combo_sub;
    if(array_nota_combo_sub.length === 0) return null;
    return (
      <React.Fragment>
        {array_nota_combo_sub.map(item => (
          <span key={uuid.v4()}  className="boton_item_child"><button onClick={ () => this.add_subitems(item.id_subgrupo,item.id_item,item.item,item.precio_venta, item.iva, item.servicio, item.sw_incluido, item.id_rubro, item.id_subrubro, item.pfinal, item.precio)} className={Number(item.precio)===0 ?"boton_item_span_child" : "boton_item_span_child_precio"}>{item.item} {Number(item.precio)===0 ?"" : "("+Number(item.precio).toFixed(2)+"$)"}</button></span>
          ))}
      </React.Fragment>
    )
  }
  onRemoveItem  = (secuencial) =>{
    this.setState(state => {
      const list = this.state.array_nota_combo_sel.filter(item => item.secuencial !== secuencial);
      return {
        array_nota_combo_sel: list,
      };
    })
  }
  addnewCombo = () =>{
    this.props.addnewCombo(this.state.array_nota_combo_sel);
  }
  renderTableSelcRows = () =>{
    const array_nota_combo_sel = this.state.array_nota_combo_sel;
    if(array_nota_combo_sel.length === 0) return null;
    return(
      <div className="divTableBody_Combo">
      {array_nota_combo_sel.map(nota => (
        <div className="divTableRow_Combo" key={uuid.v4()}>
          <div className="divTableCell_ComboA">{nota.cantidad}</div>
          <div className="divTableCell_ComboB">{nota.detalle}</div>
          <div className="divTableCell_ComboC">{Number(nota.precio_total).toFixed(2)}</div>
          <div className="divTableCell_ComboD">
            <img className="btn_eliminar_nota" onClick={() => this.onRemoveItem(nota.secuencial)} src={logo} alt="Logo" />
          </div>
        </div>
      ))}
      </div>
    )
  }
  renderTableSelc = () =>{
    return(
      <div className="divTable_Combo">
        <div className="divTableHeading_Combo">
          <div className="divTableRow_Combo">
            <div className="divTableHead_Combo">Cantidad</div>
            <div className="divTableHead_Combo">Detalle</div>
            <div className="divTableHead_Combo">Precio</div>
            <div className="divTableHead_Combo">&nbsp;</div>
          </div>
        </div>
      {this.renderTableSelcRows()}
      </div>
    )
  }

  render(){
    return (
      <React.Fragment>
      <span style={{"fontSize":"25px"}}>** SUB-COMBO: {this.state.combo}</span>
      <div className="grid-container-combo">
        <div className="lbl_area_productos">
          <div className="lbl_subgrupos">
          {this.renderTableBoton()}</div>
          <div className="lbl_combo_items">
          {this.renderTableBotonChild()}
          </div>
        </div>
        <div className="lbl_combo_nota">
          <button onClick={() => this.addnewCombo()}  className='btn_teclado' style={{"width":"45%","height":"30px","fontSize":"1.5vw"}}>Agregar Combo</button> <button className='btn_teclado' style={{"width":"45%","height":"30px","fontSize":"1.5vw"}} onClick={() => this.props.exitCombo()}>Cancelar</button>
          {this.renderTableSelc()}
        </div>
      </div>
      </React.Fragment>
    )
  }
  consultarCombo = () => {
    const id_item_combo = this.props.id_item_combo;
    //console.log(id_rubro+ " "+ this.state.id_subrubro);
    const url= this.props.url_proxyurl + this.props.url_global + "webservices/getItemsCombo/"+id_item_combo;
    //console.log(url)
      fetch(url)
      .then(res => res.json())
      .then((data) => {
        this.setState({
          array_nota_combo : data,
          combo : data[0].combo
        },()=>{
          this.validar_combo_inicial()
        })
        //c//onsole.log("ttttt "+this.state.array_nota_combo)
      })
      .catch(console.log)
  }
  validar_combo_inicial =()=>{
    const array_nota_combo = this.state.array_nota_combo;
    if(array_nota_combo.length === 0) return null;
    this.buscar_subitems(array_nota_combo[0].id_subgrupo)
  }
  componentDidMount() {

      this.consultarCombo();

  }
}
export default getSubCombo;
